export function emburseLoginEnabled(searchUri) {
    // login enabled by local storage
    if (localStorage && localStorage['emburse_login'] === 'true') {
        return true;
    }
    // login enabled by url params
    if (!URLSearchParams || !searchUri) {
        return false;
    }
    let searchParams = new URLSearchParams(searchUri);
    if (searchParams.get('useEmburseLogin') === 'true') {
        return true;
    }
    return false;
}
export function getCompanyIdFromUrl(searchUri) {
    var _a;
    if (!URLSearchParams || !searchUri) {
        return null;
    }
    const searchParams = new URLSearchParams((_a = window.location) === null || _a === void 0 ? void 0 : _a.search);
    if (!searchParams) {
        return null;
    }
    return searchParams.get('company_id');
}
